define(['jquery'], function ($) {

	var PaginationSimple = function () {
		var self = this;

		self.$ervBody = $('#erv-body');
	
		self.updateVisibleItems = function (pageSize, itemSelector, $results, $button) {
			var $hits = $results.find(itemSelector),
				index = 1;

			$hits.each(function () {
				var $hit = $(this);

				if (index <= pageSize) {
					$hit.removeClass('hide');
				} else {
					$hit.addClass('hide');
				}

				index++;
			});

			self.updateButton($hits, $button);
		}

		self.updateButton = function ($hits, $button) {
			var allVisible = $hits.filter('.hide').length === 0;
			if (allVisible) {
				$button.addClass('hide');
			} else {
				$button.removeClass('hide');
			}
		}

		self.buttonClickHandler = function (pageSize, $button, $container, itemSelector) {
			$button.off('click');
			$button.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var visibleCount = $container.find(itemSelector + ':not(.hide)').length;
				self.updateVisibleItems(pageSize + visibleCount, itemSelector, $container, $(this));
			});
		}
	};
	
	PaginationSimple.prototype.refreshSpecific = function (pageSize, $container, itemSelector, buttonSelector) {
		var self = this,
			$button = $container.find(buttonSelector);

		self.updateVisibleItems(pageSize, itemSelector, $container, $button);
	}

	PaginationSimple.prototype.init = function (pageSize, containerSelector, itemSelector, buttonSelector) {
		var self = this;

		self.$buttons = self.$ervBody.find(buttonSelector);
		self.$buttons.each(function() {
			var $button = $(this),
				$results = $button.parents(containerSelector);

			self.updateVisibleItems(pageSize, itemSelector, $results, $button);
			self.buttonClickHandler(pageSize, $(this), $results, itemSelector);
		});
	}

	return PaginationSimple;
});